/* Estelle's Closet — Collection toolbar (Filter / Sort / Grid toggle)
 * Fixed: event delegation so listeners survive Dawn's facets.js DOM replacement.
 * Fixed: visible close (X) button injected into the filter drawer header.
 * Fixed: clicking the dimmed overlay area now closes the drawer.
 */
(function () {
  'use strict';

  var GRID_STORAGE_KEY = 'ec_collection_grid_v1';
  var CLOSE_BTN_ATTR = 'data-ec-filter-close';
  var STYLE_ID = 'ec-ctb-injected-styles';

  /* ---------- Style injection ---------- */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.ec-filter-close{',
      '  flex:0 0 auto;margin-left:auto;width:36px;height:36px;',
      '  display:inline-flex;align-items:center;justify-content:center;',
      '  background:transparent;border:0;color:#000;cursor:pointer;',
      '  border-radius:50%;transition:background .15s ease;padding:0;',
      '}',
      '.ec-filter-close:hover,.ec-filter-close:focus-visible{',
      '  background:rgba(0,0,0,.06);outline:none;',
      '}',
      '.mobile-facets__wrapper details[open] .mobile-facets{pointer-events:auto;}',
      '.mobile-facets__wrapper details[open] .mobile-facets__inner{pointer-events:auto;}',
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- Drawer helpers ---------- */
  function getDrawerSummary() {
    return document.querySelector('.mobile-facets__wrapper summary');
  }

  function openFilterDrawer() {
    var summary = getDrawerSummary();
    if (summary) summary.click();
  }

  function closeFilterDrawer() {
    var details = document.querySelector('.mobile-facets__disclosure[open]');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary) summary.click();
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    document.body.style.overflow = '';
  }

  function injectFilterCloseButton() {
    var header = document.querySelector('.mobile-facets__header');
    if (!header) return;
    if (header.querySelector('[' + CLOSE_BTN_ATTR + ']')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ec-filter-close';
    btn.setAttribute(CLOSE_BTN_ATTR, '');
    btn.setAttribute('aria-label', 'Close filter');
    btn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';
    header.appendChild(btn);
  }

  /* ---------- Sort drawer ---------- */
  function openSort() {
    var sort = document.querySelector('[data-ec-sort]');
    if (!sort) return;
    sort.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSort() {
    var sort = document.querySelector('[data-ec-sort]');
    if (!sort) return;
    sort.hidden = true;
    document.body.style.overflow = '';
  }

  /* ---------- Grid view ---------- */
  function applyGrid(cols) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.remove('ec-grid-1', 'ec-grid-2');
      grid.classList.add('ec-grid-' + cols);
    }
    document.body.classList.remove('ec-grid-1', 'ec-grid-2');
    document.body.classList.add('ec-grid-' + cols);

    document.querySelectorAll('[data-ec-ctb-grid]').forEach(function (btn) {
      btn.classList.toggle(
        'ec-ctb__grid-btn--active',
        btn.getAttribute('data-ec-ctb-grid') === String(cols)
      );
    });
  }

  function loadSavedGrid() {
    var saved = null;
    try { saved = localStorage.getItem(GRID_STORAGE_KEY); } catch (e) {}
    applyGrid(saved === '1' ? 1 : 2);
  }

  /* ---------- Delegated handlers (survive DOM replacement) ---------- */
  function handleClick(e) {
    var t = e.target;

    if (t.closest('[data-ec-sort-close]')) {
      closeSort();
      return;
    }

    if (t.closest('[' + CLOSE_BTN_ATTR + ']')) {
      closeFilterDrawer();
      return;
    }

    var drawerOpen = document.querySelector('.mobile-facets__disclosure[open]');
    if (drawerOpen && t.closest('.mobile-facets') && !t.closest('.mobile-facets__inner')) {
      closeFilterDrawer();
      return;
    }

    if (t.closest('[data-ec-ctb-filter]')) {
      openFilterDrawer();
      return;
    }
    if (t.closest('[data-ec-ctb-sort]')) {
      openSort();
      return;
    }
    var gridBtn = t.closest('[data-ec-ctb-grid]');
    if (gridBtn) {
      var cols = gridBtn.getAttribute('data-ec-ctb-grid');
      applyGrid(cols);
      try { localStorage.setItem(GRID_STORAGE_KEY, cols); } catch (err) {}
      return;
    }
  }

  function handleChange(e) {
    if (e.target && e.target.name === 'sort_by' && e.target.closest('[data-ec-sort-form]')) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', e.target.value);
      window.location.search = params.toString();
    }
  }

  function handleKeydown(e) {
    if (e.key !== 'Escape') return;
    var sort = document.querySelector('[data-ec-sort]');
    if (sort && !sort.hidden) { closeSort(); return; }
    var drawerOpen = document.querySelector('.mobile-facets__disclosure[open]');
    if (drawerOpen) { closeFilterDrawer(); }
  }

  /* ---------- Drawer toggle observer ---------- */
  function watchDrawer() {
    var drawer = document.querySelector('.mobile-facets__disclosure');
    if (!drawer || drawer._ecWatched) return;
    drawer._ecWatched = true;
    drawer.addEventListener('toggle', function () {
      if (drawer.open) {
        injectFilterCloseButton();
      } else {
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    injectStyles();

    if (!window.__ecCtbBound) {
      document.addEventListener('click', handleClick);
      document.addEventListener('change', handleChange);
      document.addEventListener('keydown', handleKeydown);
      window.__ecCtbBound = true;
    }

    loadSavedGrid();
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function startObserver() {
    var target = document.getElementById('ProductGridContainer');
    if (!target) return;
    var mo = new MutationObserver(function () {
      loadSavedGrid();
      watchDrawer();
    });
    mo.observe(target, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
